import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import RadioGroup from 'devextreme-react/radio-group';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox, SelectBox } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeDriverMixerSalaryMutation,
  useCreateDriverMixerSalaryMutation,
  useLazyGetDriverMixerSalaryDetailQuery,
} from 'bus/driverMixerSalary/services/driverMixerSalary';
import { DriverMixerSalaryItemCreate } from 'bus/driverMixerSalary/types';

type Props = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  objectId: number | null;
};

export const quantity = [
  {
    name: '10',
    value: 10,
  },
  {
    name: '12',
    value: 12,
  },
  {
    name: '15',
    value: 15,
  },
];

const initialForm: DriverMixerSalaryItemCreate = {
  id: null,
  dateBegin: '',
  factoryId: null,
  nonResidentSalary: 0,
  objectId: null,
  quantity: 10,
  residentSalary: 0,
};

const DriverMixerSalaryModalCreate: FC<Props> = ({ changeVisible, refresh, visible, id, objectId }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);
  const [changeDriverMixerSalary, { isLoading: isLoadingChange }] = useChangeDriverMixerSalaryMutation();
  const [createDriverMixerSalary, { isLoading: isLoadingCreate }] = useCreateDriverMixerSalaryMutation();
  const [getDriverMixerSalaryDetail] = useLazyGetDriverMixerSalaryDetailQuery();

  const [form, setForm] = useState<DriverMixerSalaryItemCreate>(initialForm);

  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const onShown = async () => {
    if (id) {
      const result = await getDriverMixerSalaryDetail({ id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeDriverMixerSalary(form);
      } else {
        const temp = { ...form, objectId };
        //@ts-ignore
        delete temp.id;
        await createDriverMixerSalary(temp);
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="ЗП миксеристов"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Площадка" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={factoryDataStore}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.factoryId}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, factoryId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Площадку" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Площадку" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                        <AppFiledBox label="" labelTop>
                          <RadioGroup
                            items={quantity}
                            value={form.quantity}
                            layout="horizontal"
                            onValueChanged={({ value }) => {
                              setForm((prev) => ({ ...prev, quantity: value }));
                            }}
                            valueExpr="value"
                            displayExpr="name"
                          />
                        </AppFiledBox>

                        <AppFiledBox label="Дата начала" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, dateBegin: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>

                        <AppFiledBox label="ЗП резидента" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Введите ЗП / резидента"
                            format="###0.##"
                            value={form.residentSalary!}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, residentSalary: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле ЗП / резидента" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>

                        <AppFiledBox label="ЗП нерезидента" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Введите ЗП / нерезидента"
                            format="###0.##"
                            value={form.nonResidentSalary!}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, nonResidentSalary: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле ЗП / нерезидента" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  disabledSubmit={isLoadingCreate || isLoadingChange}
                  hideModal={() => changeVisible(false)}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default DriverMixerSalaryModalCreate;
